import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import StaticPageHeader from '../components/common/StaticPageHeader'
import { setCartCount } from '../store/reducers/auth'
import { cartsData, currencyData } from '../utils/constants'
import { getFromLocalStorage, saveToLocalStorage } from '../utils/localStorageUtils'
import { getConvertedPrice } from '../utils/Utilities'
import { callPostWebservice } from '../hooks/api'

const Cart = () => {
    const merchantSettings = useSelector((state) => state.general.merchantSettings);
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const [carts, setCarts] = useState(getFromLocalStorage(cartsData));
    const [price, setPrice] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        calculatePrice();
    }, [carts]);

    const handleDelete = (index) => {
        const updatedCarts = carts.filter((_, i) => i !== index);
        if (!isLoggedIn) {
            updateCartCount(true, updatedCarts);
            return;
        }
        if (updatedCarts) {
            let requestPacket = {
                products: updatedCarts,
                outlet_id: merchantSettings?.outlet?.id
            }
            if (updatedCarts.length === 0) {
                requestPacket['clear_cart'] = true;
            }
            callPostWebservice('add-to-cart', requestPacket, (response) => {
                updateCartCount(true, updatedCarts);
            }, (error) => {
            }, dispatch, navigate);
        }
    };

    const updateCartCount = (isDelete, updatedCarts) => {
        if (isDelete) {
            alert('Deleted item from cart');
        } else {
            // No alert for quantity updates to avoid spamming
        }
        setCarts(updatedCarts);
        saveToLocalStorage(cartsData, updatedCarts);
        dispatch(setCartCount(updatedCarts.length));
    }

    const handleQuantityChange = (index, delta) => {
        const updatedCarts = [...carts];
        const newQuantity = Math.max(1, Math.min(10, (updatedCarts[index].quantity || 1) + delta));

        if (newQuantity === updatedCarts[index].quantity) return;

        updatedCarts[index] = { ...updatedCarts[index], quantity: newQuantity };

        if (!isLoggedIn) {
            updateCartCount(false, updatedCarts);
            return;
        }

        let requestPacket = {
            products: updatedCarts,
            outlet_id: merchantSettings?.outlet?.id
        }

        callPostWebservice('add-to-cart', requestPacket, (response) => {
            updateCartCount(false, updatedCarts);
        }, (error) => {
            alert('Failed to update quantity');
        }, dispatch, navigate);
    };

    const calculatePrice = () => {
        let totalPrice = 0;
        let currency = getFromLocalStorage(currencyData);
        carts?.forEach((cart) => {
            let quantity = cart.quantity || 1;
            let variant = cart.selected_variant;
            totalPrice += getConvertedPrice(variant.sale_price) * quantity;
        });
        setPrice({
            'subTotal': totalPrice?.toFixed(2),
            'total': totalPrice?.toFixed(2),
            'currency': currency?.currency?.symbol || 'Rs.'
        })
    }

    return (
        <div className="static-page-wrapper">
            <StaticPageHeader title="Shopping Cart" />

            <div className="container static-page-container">
                <div className="static-page-content" style={{ padding: '30px' }}>
                    <div className="row justify-content-center">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="sec_title position-relative text-center mb-5">
                                <h2 className="ft-bold pt-3" style={{ border: 'none', margin: 0 }}>Your Shopping Cart</h2>
                                <p className="text-muted fs-md" style={{ marginTop: '10px' }}>Review your items and proceed to checkout</p>
                            </div>
                        </div>
                    </div>

                    {carts?.length > 0 ? (
                        <div className="row justify-content-between g-4">
                            <div className="col-12 col-lg-7 col-md-12">
                                <div className="cart-items-container animate__animated animate__fadeInLeft">
                                    {carts?.map((cart, index) => {
                                        const item = cart;
                                        const variant = cart.selected_variant;
                                        return (
                                            <div key={`cart-${index}`} className="cart-item-card">
                                                <div className="row align-items-center">
                                                    <div className="col-4 col-md-3">
                                                        <div className="item-image">
                                                            <img src={item.image} alt={item.name} />
                                                        </div>
                                                    </div>
                                                    <div className="col-8 col-md-9">
                                                        <div className="item-details">
                                                            <div className="item-header">
                                                                <h4 className="item-name">{item.name}</h4>
                                                                <button
                                                                    className="remove-item"
                                                                    onClick={() => handleDelete(index)}
                                                                    title="Remove Item"
                                                                >
                                                                    <i className="fas fa-times"></i>
                                                                </button>
                                                            </div>

                                                            <div className="item-variants">
                                                                {item.selected_variant?.item_variant_attributes?.map((attr, idx) => (
                                                                    <span key={idx} className="variant-tag">
                                                                        {attr.name}: {attr.item_attribute_value?.value}
                                                                    </span>
                                                                ))}
                                                            </div>

                                                            <div className="item-footer">
                                                                <div className="quantity-control-modern">
                                                                    <button
                                                                        className="qty-btn"
                                                                        onClick={() => handleQuantityChange(index, -1)}
                                                                        disabled={item.quantity <= 1}
                                                                    >
                                                                        <i className="fas fa-minus"></i>
                                                                    </button>
                                                                    <span className="qty-num">{item.quantity || 1}</span>
                                                                    <button
                                                                        className="qty-btn"
                                                                        onClick={() => handleQuantityChange(index, 1)}
                                                                        disabled={item.quantity >= 10}
                                                                    >
                                                                        <i className="fas fa-plus"></i>
                                                                    </button>
                                                                </div>
                                                                <div className="item-price">
                                                                    {price?.currency} {getConvertedPrice(variant.sale_price)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                    <div className="cart-actions">
                                        <Link to="/" className="btn-update-cart text-decoration-none">
                                            <i className="fas fa-arrow-left"></i>
                                            Back to Menu
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-12 col-lg-4 animate__animated animate__fadeInRight">
                                <div className="order-summary-card">
                                    <h5 className="summary-header">Order Summary</h5>

                                    <div className="summary-body">
                                        <div className="summary-row">
                                            <span>Subtotal</span>
                                            <span>{price.currency} {price.subTotal}</span>
                                        </div>
                                        <div className="summary-row">
                                            <span>Tax</span>
                                            <span>{price.currency} 0.00</span>
                                        </div>
                                        <div className="summary-row total">
                                            <span>Total</span>
                                            <span>{price.currency} {price.total}</span>
                                        </div>
                                        <div className="shipping-note">
                                            * Shipping and taxes calculated at checkout
                                        </div>
                                    </div>

                                    <Link to="/checkout" className="btn-checkout-premium text-decoration-none">
                                        Review & Checkout
                                        <i className="fas fa-chevron-right ms-2"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="empty-cart-container animate__animated animate__zoomIn">
                            <div className="empty-cart-content">
                                <div className="empty-cart-icon">
                                    <i className="fas fa-shopping-basket"></i>
                                </div>
                                <h3>Your basket is empty</h3>
                                <p>Sounds like a good time to start your next feast!</p>
                                <Link to="/productlist" className="text-decoration-none">
                                    <div className="position-relative text-center mt-3">
                                        <span className="btn-fine btn-primary-fine px-5">Explore Our Menu</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Cart;